/**
 * Copyright (c) 2026, CYBRA Corp. All rights reserved.
 */
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { PvhReasonCodeAndComment, PvhReasonCodeOption } from "app/services/pvh.scan-chamber.service";

/** Declare $ to call bootstrap */
declare var $: any;

/**
 * Dialog component that allows the User to select a Reason Code Option and optionally enter
 * a comment to tie to a Scan Chamber attempt.
 */
@Component({
  selector: 'ef-pvh-reason-code-dialog',
    templateUrl: './pvh.scan-chamber.reason-code-and-comments.dialog.component.html',
    styleUrls: [
      '../../../../../../assets/css/infrastructure.css'
    ]
  })
export class PvhScanChamberReasonCodeAndCommentsDialog {

  /** Reason Code Options available to the User */
  @Input()
  availableReasonCodeOptions?: PvhReasonCodeOption[];

  /** Output used to pass the selected Reason Code and User Entered Comment to the parent */
  @Output()
  userEnteredValues = new EventEmitter<PvhReasonCodeAndComment>();

  /** User selected Reason Code Option */
  @Input()
  selectedReasonCode?: PvhReasonCodeOption;
  selectedReasonCodeUi?: PvhReasonCodeOption;

  /** Optional User entered comment */
  @Input()
  comment?: string = "";
  commentUi?: string = "";


  /** Constructor */
  constructor() { }


  /** 
   * Shows the Dialog  
   */
  public show(): void {
    if (!this.selectedReasonCode) {
      this.selectedReasonCode = undefined;
    } 
    this.selectedReasonCodeUi = this.selectedReasonCode;
    if (!this.comment) {
      this.comment = "";
    }
    this.commentUi = this.comment;
    $("#reasonCodeDialog").modal("show");
  }

  /**
   * Hides the Dialog
   */
  public hide(): void {
    $("#reasonCodeDialog").modal("hide");
  }

  /**
   * Called when the "Cancel" UI Button is clicked.
   * Cancels / Hides the Dialog
   */
  onCancelClicked(): void {
    this.hide();
    this.selectedReasonCodeUi = this.selectedReasonCode;
    this.commentUi = this.comment;
  }

  /**
   * Called when the User changes the selected Reason Code. 
   * Used to clear the comment if they are no longer allowed / required.
   */
  onReasonCodeChanged(): void {
    console.log(`onReasonCodeChanged()\n\tReason Code: ${this.selectedReasonCodeUi? JSON.stringify(this.selectedReasonCodeUi) : 'undefined'}`);
    if (!this.selectedReasonCodeUi?.allows_comments) {
      this.commentUi = "";
    }
  }

  onSetClicked(): void {
    const reasonCode = this.selectedReasonCodeUi? this.selectedReasonCodeUi : undefined;
    const comment = reasonCode?.allows_comments && this.commentUi? this.commentUi : undefined;
    this.userEnteredValues.emit({ reasonCode: this.selectedReasonCodeUi, comment: comment } as PvhReasonCodeAndComment);
  }

}
